import { GeoFence } from '@/feature/observatory/types/GeoFence.types'
import { createNetworkRequestHook } from '@/utils/createNetworkRequestHook'
import { createPaginatedNetworkRequestHook } from '@/utils/createPaginatedNetworkRequestHook'

import { NetworkParams } from '@/lib/core/hooks/usePaginatedNetworkResource'
import { ListFilters } from '@/lib/core/interfaces/common.types'

export const useSingleGeoFence = createNetworkRequestHook<GeoFence, { id?: number }>(
  'v1/geofences/${params.id}/',
)
export const useGeoFences = createPaginatedNetworkRequestHook<GeoFence>('v1/geofences')

export const useGeofencesAsideHttp = createPaginatedNetworkRequestHook<
  GeoFence,
  NetworkParams<ListFilters & { fleetName: string }>
>('v1/geofences/${params.fleetName}/geofence-aside/')
